export interface DualColor {
  light: string;
  dark: string;
}

export interface DualPalette {
  [key: string]: DualColor;
}

export type ColorMode = "light" | "dark";

export function pick<T extends { light: any; dark: any }>(
  dual: T,
  mode: ColorMode
) {
  return dual[mode];
}
